import template from './table-cell.html';

export default {
  template,
  bindings: {
    header: '@?',
    textAlignment: '@?'
  },
  transclude: true,
};



// WEBPACK FOOTER //
// ./src/modules/utils/grid/table-cell-component.js